import { render, staticRenderFns } from "./assignModal.vue?vue&type=template&id=e9af541a&scoped=true&"
import script from "./assignModal.vue?vue&type=script&lang=js&"
export * from "./assignModal.vue?vue&type=script&lang=js&"
import style0 from "./assignModal.vue?vue&type=style&index=0&id=e9af541a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9af541a",
  null
  
)

export default component.exports